import api from './axios.js';

function timeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

export const dashboardApi = {
  summary: (range = '7d') => api.get('/dashboard/summary', { params: { range, tz: timeZone() } }),
  attention: () => api.get('/dashboard/attention'),
  callbacks: (days = 7) => api.get('/dashboard/callbacks', { params: { days } }),
  notifications: () => api.get('/dashboard/notifications'),
  search: (q) => api.get('/dashboard/search', { params: { q } }),
  reports: (range = '30d') => api.get('/dashboard/reports', { params: { range, tz: timeZone() } }),
  activity: (page = 1) => api.get('/dashboard/activity', { params: { page } }),
};

export const savedRepliesApi = {
  list: () => api.get('/saved-replies'),
  create: (data) => api.post('/saved-replies', data),
  update: (id, data) => api.put(`/saved-replies/${id}`, data),
  delete: (id) => api.delete(`/saved-replies/${id}`),
};
